import React from 'react';
import { DmsAltBox } from 'dmsbasereact';
import { Typography, Box, Stack, Card, CardContent, Divider, useTheme } from '@mui/material';

export const TopLists = ({ topBranches, topPharmacists, intl, formatNumberValue }) => {
    const theme = useTheme();
    return (
        <DmsAltBox.Card sx={{
            display: "flex",
            flexDirection: "column",
            width: '100%',
            minHeight: '30vh',
            maxHeight: '80vh'
        }}>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl
                        .get("DispensationInsights.TopSectionTitle")
                        .d("Highlights by Institution and Pharmacist")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto",
                    p: 2,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: theme.palette.grey[100],
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.palette.grey[400],
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: theme.palette.grey[500],
                        },
                    },
                }}
            >
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                        <Typography variant="subtitle2" sx={{
                            mb: 1,
                            top: 0,
                            bgcolor: 'background.paper',
                            zIndex: 1,
                            pb: 1,
                        }}>
                            {intl
                                .get("DispensationInsights.TopBranches")
                                .d("Top Institutions (Dispensed Box Count)")}
                        </Typography>
                        <Stack spacing={1} sx={{ width: '100%' }}>
                            {topBranches.length === 0 && (
                                <Typography variant="body2" color="text.secondary">
                                    {intl
                                        .get("DispensationInsights.EmptyTopBranches")
                                        .d("No divergence recorded for the selected filters.")}
                                </Typography>
                            )}
                            {topBranches.map((item) => (
                                <Card
                                    key={`branch-${item.identifier}`}
                                    variant="outlined"
                                    sx={{ width: '100%' }}
                                >
                                    <CardContent sx={{ py: 1.5 }}>
                                        <Typography variant="subtitle2" noWrap>
                                            {item.label}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {intl
                                                .get("DispensationInsights.DispensedBoxCount")
                                                .d("Dispensed Box Count")}: {item.total_dispensed}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    </Box>

                    <Divider />

                    <Box sx={{ width: '100%' }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                mb: 1,
                                top: 0,
                                bgcolor: 'background.paper',
                                zIndex: 1,
                                pb: 1,
                            }}
                        >
                            {intl
                                .get("DispensationInsights.TopPharmacists")
                                .d("Top Pharmacists (Dispensed Box Count)")}
                        </Typography>

                        <Stack spacing={1} sx={{ width: '100%' }}>
                            {topPharmacists.length === 0 && (
                                <Typography variant="body2" color="text.secondary">
                                    {intl
                                        .get("DispensationInsights.EmptyTopPharmacists")
                                        .d("No pharmacist divergence recorded for the selected filters.")}
                                </Typography>
                            )}
                            {topPharmacists.map((item) => (
                                <Card
                                    key={`pharmacist-${item.identifier}`}
                                    variant="outlined"
                                >
                                    <CardContent>
                                        <Typography variant="subtitle2" noWrap>
                                            {item.label}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {intl
                                                .get("DispensationInsights.DispensedBoxCount")
                                                .d("Dispensed Box Count")}: {formatNumberValue(item.total_dispensed)}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    </Box>
                </Stack>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );
};
